import React, { useEffect, useState, useContext } from 'react';
import { CircularProgress } from '@material-ui/core';
import TxFormGenerator from '../../generators/TxFormGenerator';
import { GlobalsContext } from '../../store/Globals';
import { InputTypes, InputType } from '../../store/inputs/types';

import { Container, LoadingContainer } from './styles';
import { CreateTypeInputs, CreatePropInput, DeleteTypeInputs } from './utils';
import { Caller } from '../../types/Caller';

const DynamicTxFormScreen: React.FC<{
  tx: {
    label: string;
    tag: string;
    method: string;
    args: Record<string, any>[] | Record<string, any>;
    description: string;
    callers: string[] | Caller[];
  };
}> = ({ tx }) => {
  const globals = useContext(GlobalsContext);
  const [inputs, setInputs] = useState<InputTypes[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTxInputs = async () => {
      if (tx.tag === 'createAssetType') {
        setInputs(
          CreateTypeInputs.map((ip: InputType) => ({
            ...ip,
            dataType: globals.dataTypeBase(ip.dataType),
            dropDownValues: globals.getDropDownValues(ip.dataType),
          })),
        );
        setInputs((prev) => [...prev, CreatePropInput]);
      }

      if (tx.tag === 'deleteAssetType') {
        const dropdownValues: { [key: string]: number } = {};
        globals.assetList.forEach(
          (value: { tag: string; dynamic: boolean }, index: number) => {
            if (value.dynamic === true) {
              dropdownValues[value.tag] = index;
            }
          },
        );
        setInputs(
          DeleteTypeInputs.map((ip: InputType) => ({
            ...ip,
            dataType: ip.tag === 'tag' ? 'number' : ip.dataType,
            dropDownValues: ip.tag === 'tag' ? dropdownValues : undefined,
          })),
        );
      }
      setLoading(false);
    };
    if (tx.args) {
      getTxInputs();
    }
  }, [tx.tag, tx.args, globals]);

  if (loading)
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );

  return (
    <Container headerHeight={globals.headerHeight}>
      <TxFormGenerator tx={{ name: tx, inputs }} />
    </Container>
  );
};

export default DynamicTxFormScreen;
